import { shallowEqual, useDispatch, useSelector } from 'react-redux';
import flatMap from 'lodash/flatMap';

import { IBindingCard } from '@r1-frontend/api-domru/api-profile/v2/info/all/dto/ResponseDto';

import { EAdditionalMethodId, IMethodData } from '@r1-frontend/ui-react/organisms/Payment/PaymentMethod';
import PaymentMethod from '@r1-frontend/ui-react/organisms/Payment/PaymentMethod';

import { addCardMethods } from '~/src/features/payments-abn/store/actions/addNewPayMethods';
import { selectCardsWithPaySystem } from '~/src/features/payments-abn/store/selectors/cards';
import { TState } from '~/src/store';

import { SaveNewCard } from './SaveNewCard';

const newCardMethod: IMethodData = {
    id: EAdditionalMethodId.newCard,
    methodType: 'new-card',
    label: '',
    value: 'new-card',
    imagePath: '/static/images/payments-abn/new-card.png',
    imageAlt: 'Логотип банковской карты',
    isAutoPayConnected: false,
    isIcon: true,
    additionalBlock: SaveNewCard,
    widget: PaymentMethod,
};

/**
 * Добавляет методы оплаты ранее сохраненными картами
 */
export const useCardPayment = (): void => {
    const dispatch = useDispatch();

    const { isAuth, items } = useSelector((state: TState) => ({
        isAuth: state.auth.isAuth,
        items: selectCardsWithPaySystem(state),
    }), shallowEqual);

    newCardMethod.label = isAuth ? 'Новая карта' : 'Картой';

    const { isCards, cardGroups } = items || {};

    if (isCards) {
        const _cards: IBindingCard[] = flatMap(cardGroups, 'cardsList');

        _cards.sort(_card => _card.autoPayStatus ? -1 : 1);

        const result: IMethodData[] = _cards.map(_card => (
            {
                id: _card.id.toString(),
                methodType: 'card',
                label: _card.numberWithPaySystem || '',
                value: 'card',
                imagePath: `/static/images/payments-abn/${_card.paySystem ? 'pay-systems/' + _card.paySystem : 'stub'}.png`,
                imageAlt: `Логотип ${_card.paySystem || 'банковской карты'}`,
                isAutoPayConnected: _card.autoPayStatus,
                widget: PaymentMethod,
            }
        ));

        if (result.length) {
            dispatch(addCardMethods([...result, newCardMethod]));
        }
    } else {
        dispatch(addCardMethods([newCardMethod]));
    }
};
